angular.module('terminalApp.nabLuckySixUi').controller('LuckySixController', function (
  $scope,
  SevenGamesSvc
) {
  $scope.activeGame = SevenGamesSvc.getGame('LuckySix');
  $scope.activeBets = $scope.activeGame.getBettingSvc();
});
